import { Component, ChangeDetectionStrategy } from '@angular/core';
import { LibTableComponent } from '@tuain/ng-forms';
import { tuainFormsBaseModules, tuainBaseComponents } from '@components/tuain.modules';
import { TableCustomActionComponent } from './custom-action/custom-action.component';

@Component({
  standalone: true,
  selector: 'app-documents-upload-table',
  imports: [...tuainFormsBaseModules, ...tuainBaseComponents, TableCustomActionComponent],
  templateUrl: './insurances-table.component.html',
  styleUrls: ['./insurances-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InsurancesTableComponent extends LibTableComponent {
  insuranceActions: any = {};

  override start() {
    super.start();
    this.inlineActions.forEach(act => {
      this.insuranceActions[act.actionCode] = act;
    });
  }
}
